<div class="container">
    <section class="grid-sidebar" role="search" aria-label="Suchmaske">
        <app-filters></app-filters>
    </section>
    <div class="grid-content">
        <app-hitlist></app-hitlist>
    </div>
</div>
